import React from 'react'
import Translation from '../global/Translation'

import { injectIntl } from 'react-intl'

import { showingSegmentationModal } from '../../store/ui/reducers'
import * as ui from '../../store/ui/actions'
import { connect } from 'react-redux'
import SegmentationContainer from './SegmentationContainer'
import { getSegmentationCurrentStep, getSegmentatingProductId } from '../../store/segmentation/reducers'
import {
    SAVED_SEGMENTATIONS_STEP, SAVING_SEGMENTATION_STEP,
    SEGMENTATION_EVIDENCE_STEP, SEGMENTATION_SUCCESSFULLY_SAVED,
    SEGMENTATION_V3_STEP,
    SUGGESTED_SEGMENTATIONS_STEP
} from "./SegmentationSteps";
import { byProductId, getFetchedProducts, getCframeQty, getError } from '../../store/products/reducers'
import { getPendingCartLine } from '../../store/cart/reducers'
import { fetchProduct } from "../../store/products/actions";
import ComplementaryProductCframe from '../catalog/complementary-product-cframe/ComplementaryProductCframe'
import ProductTypes from "../../components/catalog/ProductTypes";
import { getLanguage } from '../../store/ui/reducers'
import { getCframeProductIdByEnv } from '../../store/products/reducers'

const CFRAME_PRODUCT_ID = getCframeProductIdByEnv()
const mapStateToProps = state => {

    const product = byProductId(state, getSegmentatingProductId(state))
    const fetchedProducts = getFetchedProducts(state)
    const cframeProduct = fetchedProducts && fetchedProducts.find(item => item.product.productId == CFRAME_PRODUCT_ID)
    const pendingCartLine = getPendingCartLine(state)
    const cframeQty = product && pendingCartLine ? getCframeQty(product.format, pendingCartLine.qty) : 0

    return {
        show: showingSegmentationModal(state),
        segmentationCurrentStep: getSegmentationCurrentStep(state),
        fromCartLine: state.segmentation.fromCartLine,
        segmentatingProduct: product,
        cframeProduct: cframeProduct,
        cframeQty: cframeQty,
        cframeProductError: getError(state),
        language: getLanguage(state),
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onClose: () => {
            dispatch(ui.closeSegmentationModal())
        },
        fetchCframeProduct: () => dispatch(fetchProduct(CFRAME_PRODUCT_ID)),
    }
}

class SegmentationModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            cframeStepDone: false
        }
    }

    componentDidUpdate(prevProps) {
        const { show, segmentatingProduct, cframeQty, fetchCframeProduct } = this.props
        if (show && !prevProps.show) {
            this.setState({ cframeStepDone: false })  // reset al abrir
            const needsCframeStep = segmentatingProduct
                && ProductTypes.getStandardTypes().includes(segmentatingProduct.type)
                && cframeQty > 0
            if (needsCframeStep) {
                fetchCframeProduct()
            }
        }
    }

    render() {
        const { show, onClose, segmentationCurrentStep, fromCartLine, cframeProduct, cframeQty, segmentatingProduct, cframeProductError, language } = this.props
        const { cframeStepDone } = this.state

        let modalLabel
        switch (segmentationCurrentStep) {
            case SAVED_SEGMENTATIONS_STEP:
                modalLabel = <Translation id="choose_saved_segmentation" defaultMessage="Choose saved segmentation" />
                break
            case SAVING_SEGMENTATION_STEP:
                modalLabel = <Translation id="saving_segmentation" defaultMessage="Saving segmentation" />
                break
            case SEGMENTATION_EVIDENCE_STEP:
                modalLabel = <Translation id="attach_evidence" defaultMessage="Attach evidence" />
                break
            case SEGMENTATION_SUCCESSFULLY_SAVED:
                modalLabel = <Translation id="segmentation_successfully_saved" defaultMessage="Segmentation successfully saved" />
                break
            case SEGMENTATION_V3_STEP:
                {
                    fromCartLine ?
                        modalLabel = <Translation id="edit_segmentation" defaultMessage="Edit segmentation" />
                        :
                        modalLabel = <Translation id="choose_segmentation_manually" defaultMessage="Choose segmentation manually" />
                }
                break
            case SUGGESTED_SEGMENTATIONS_STEP:
            default:
                modalLabel = <Translation id="choose_segmentation" defaultMessage="Choose segmentation" />
        }

        if (!show) return (
            <React.Fragment />
        )

        const needsCframeStep = !cframeStepDone
            && segmentatingProduct
            && ProductTypes.getStandardTypes().includes(segmentatingProduct.type)
            && cframeQty > 0

        if (needsCframeStep) {
            return (
                <ComplementaryProductCframe
                    cframeProduct={cframeProduct && cframeProduct.product ? cframeProduct.product : null}
                    cframeQty={cframeQty}
                    cframeProductError={cframeProductError}
                    onClose={() => this.setState({ cframeStepDone: true })}
                    language={language}
                />
            )
        }

        return (
            <div>
                <div className="full-overlay" style={{ display: show ? 'block' : 'none' }} onClick={onClose} />
                {show &&
                    <div id="modal-segmentation-container" className="modal-segmentation container segmentation">
                        <header>
                            <div className="d-flex align-items-center justify-content-between pb-3">
                                <div>
                                    <h4 className="m-0">
                                        {modalLabel}
                                    </h4>
                                </div>
                                <div>
                                    <div className="bt-close" onClick={onClose}>
                                        <i className="fal fa-times" />
                                    </div>
                                </div>
                            </div>
                        </header>
                        <SegmentationContainer modal />
                    </div>
                }
            </div>
        )
    }
}
export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(SegmentationModal)
)
